import { createApp } from 'vue'
import { auth0 } from 'Common/plugins/auth0'
import './style.css'
import App from './App.vue'
import AppHistory from 'Common/plugins/appHistory'
import { createPinia } from 'pinia'
import ElementPlus from 'element-plus'
import FontAwesomeIcon from './icons'
import { router } from './modules/RouterSetup.js'
import { VueQueryPlugin } from '@tanstack/vue-query'
import 'element-plus/dist/index.css'
import { cleanupPlugin } from './plugins/cleanupPlugin' // Adjust the path as needed

const app = createApp(App)
const pinia = createPinia()

app.use(ElementPlus)
app.use(router)
app.use(AppHistory, { router: router })
app.use(auth0)
app.use(VueQueryPlugin)
app.use(pinia)
app.use(cleanupPlugin)
app.component('FontAwesomeIcon', FontAwesomeIcon)
app.mount('#app')
